import { render, staticRenderFns } from "./UserInputPage.vue?vue&type=template&id=4707dac9&scoped=true&"
import script from "./UserInputPage.vue?vue&type=script&lang=ts&"
export * from "./UserInputPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4707dac9",
  null
  
)

export default component.exports